import { defineComponent, onMounted, ref } from "vue";
import { useReviewsStore } from "./customerReviewsStore";
import DealerDetailsComponent from "./dealerDetails.vue";
import FiltersComponent from "./filters.vue";
import CommentsComponent from "./comments.vue";
export default defineComponent({
    name: "App",
    components: {
        DealerDetailsComponent,
        FiltersComponent,
        CommentsComponent,
    },
    setup() {
        const store = useReviewsStore();
        let hasReviews = ref(false);
        onMounted(async () => {
            assignDealerInfo();
            await store.loadDataVersion();
            await store.loadDealerInfo();
            await store.loadDealerDetails();
            await store.loadCustomerReviews();
            hasReviews.value = store.getCustomerReviews.length > 1;
        });
        function assignDealerInfo() {
            const vueAppElement = document.getElementById("customerReviews");
            const dealerIdAttribute = vueAppElement.dataset.dealer;
            if (dealerIdAttribute) {
                store.dealerId = parseInt(dealerIdAttribute);
            }
            const dealerNameAttribute = vueAppElement.dataset.dealerName;
            if (dealerNameAttribute) {
                store.dealerName = dealerNameAttribute;
            }
        }
        return {
            hasReviews,
        };
    },
});
